import api from "@/lib/api";
import type { QuestionUpdatePayload } from "../types";
import type { ApiDilemmaQuestion } from "../../dilemmas/types";

const QUESTIONS_ENDPOINTS = {
  GET_ONE: (id: string) => `/questions/${id}/`,
  UPDATE: (id: string) => `/questions/${id}/`,
};

export class QuestionsHttpRepository {
  async fetchOne(id: string): Promise<ApiDilemmaQuestion> {
    const result = await api.get(QUESTIONS_ENDPOINTS.GET_ONE(id));
    return result.data;
  }
  async patch(
    id: string,
    payload: Partial<QuestionUpdatePayload>,
  ): Promise<ApiDilemmaQuestion> {
    const result = await api.patch(QUESTIONS_ENDPOINTS.UPDATE(id), payload);
    return result.data;
  }
}
